import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-final-action',
  templateUrl: './final-action.component.html',
  styleUrls: ['./final-action.component.css']
})
export class FinalActionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/parts/final-action/final-action.component.ts